// 帖子图片
function id2ImgView(id, size) {
  const url = `https://file.izuiyou.com/img/view/id/${id}`;
  const sizeTail = size ? `/sz/${size}` : '';
  return url + sizeTail;
}

// 用户头像
function id2ImgAvatar(id) {
  return `https://file.izuiyou.com/account/avatar/id/${id}`;
}

// 话题封面
function id2ImgTopic(id) {
  return `https://file.izuiyou.com/topic/cover/id/${id}`;
}

export {id2ImgView, id2ImgAvatar, id2ImgTopic};


// WEBPACK FOOTER //
// ./src/tools/lib/idToImg.js